(function(){
  const HS = window.HS || {};
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

  function money(cents){
    const fmt = HS.moneyFormat || '${{amount}}';
    const n = cents/100;
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
      k === 'amount_no_decimals' ? Math.round(n).toLocaleString('en-US') :
      k === 'amount_with_comma_separator' ? two.replace('.', ',') : two);
  }

  /* ---------- product cards ---------- */
  $$('[data-product]').forEach(card => {
    let products;
    try { products = $$('[data-json]', card).map(s => JSON.parse(s.textContent)); } catch(e){ return; }
    let product = products[0];
    const add = $('[data-add]', card), priceEl = $('[data-price]', card);
    const img = $('[data-img]', card), link = $('[data-link]', card), thumbs = $('[data-thumbs]', card);

    function gallery(){
      const g = product.gallery || [];
      if(img && g[0]) img.src = g[0];
      if(!thumbs) return;
      thumbs.innerHTML = g.length > 1 ? g.map((u,i) => `<button type="button" data-thumb="${i}" aria-pressed="${i===0}" aria-label="View image ${i+1}"><img src="${esc(u)}" alt="" loading="lazy"></button>`).join('') : '';
    }
    function selected(){
      const sel = [];
      $$('[data-option]', card).forEach(g => { const on = $('[aria-pressed="true"]', g); sel[+g.dataset.option] = on ? on.dataset.value : null; });
      return sel;
    }
    function sync(){
      const sel = selected();
      const v = product.variants.find(v => v.options.every((o,i) => sel[i] == null || o === sel[i]));
      if(link) link.href = HS.root + 'products/' + product.handle;
      if(!v){ add.disabled = true; add.textContent = 'Unavailable'; return; }
      add.dataset.variant = v.id;
      priceEl.textContent = money(v.price);
      const closed = card.dataset.closed === '1';
      add.disabled = closed || !v.available;
      add.textContent = closed ? 'Archived' : (v.available ? 'Add to cart' : 'Sold out');
    }
    card.addEventListener('click', e => {
      const th = e.target.closest('[data-thumb]');
      if(th){ img.src = product.gallery[+th.dataset.thumb]; $$('[data-thumb]', card).forEach(b => b.setAttribute('aria-pressed', b === th)); return; }
      const cw = e.target.closest('[data-colorway] button');
      if(cw){ $$('button', cw.parentElement).forEach(b => b.setAttribute('aria-pressed', b === cw)); product = products[+cw.dataset.p] || products[0]; gallery(); sync(); return; }
      const chip = e.target.closest('[data-option] button');
      if(chip){ $$('button', chip.parentElement).forEach(b => b.setAttribute('aria-pressed', b === chip)); sync(); return; }
      if(e.target.closest('[data-add]') && !add.disabled) addToCart(+add.dataset.variant, product.title);
    });
    card._sync = sync;
    gallery(); sync();
  });

  /* ---------- cart ---------- */
  const drawer = $('[data-drawer]'), scrim = $('[data-scrim]');
  function openCart(o){ drawer.hidden = !o; scrim.hidden = !o; }
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', () => { refreshCart(); openCart(true); }));
  $('[data-close-cart]').addEventListener('click', () => openCart(false));
  scrim.addEventListener('click', () => openCart(false));
  document.addEventListener('keydown', e => { if(e.key === 'Escape') openCart(false); });

  async function addToCart(id, title){
    try{
      const r = await fetch(HS.root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id, quantity:1 }] }) });
      if(!r.ok){ const j = await r.json().catch(()=>({})); toast(j.description || 'Could not add that. Try again.'); return; }
      await refreshCart(); openCart(true); toast('Added to cart');
    }catch(e){ toast('Could not reach the store. Check your connection.'); }
  }
  async function refreshCart(){
    const cart = await fetch(HS.root + 'cart.js', { headers:{'Accept':'application/json'} }).then(r => r.json());
    $$('[data-count]').forEach(el => el.textContent = cart.item_count);
    $('[data-total]').textContent = money(cart.total_price);
    $('[data-lines]').innerHTML = cart.items.length ? cart.items.map(i => `
      <div class="line"><strong>${esc(i.product_title)}</strong><span class="price">${money(i.final_line_price)}</span>
      <span class="meta">${esc(i.variant_title || '')} · Qty ${i.quantity}</span><button class="rm" data-rm="${esc(i.key)}" type="button">Remove</button></div>`).join('')
      : '<p class="note">Nothing in here yet.</p>';
  }
  $('[data-lines]').addEventListener('click', async e => {
    const b = e.target.closest('[data-rm]'); if(!b) return;
    await fetch(HS.root + 'cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id:b.dataset.rm, quantity:0 }) });
    refreshCart();
  });
  let tt; function toast(m){ const t = $('[data-toast]'); t.textContent = m; t.hidden = false; clearTimeout(tt); tt = setTimeout(() => t.hidden = true, 2000); }

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach(box => {
    const end = new Date(box.dataset.countdown);
    if(!box.dataset.countdown || isNaN(end)) return;
    const pad = n => String(n).padStart(2,'0');
    function tick(){
      let ms = end - new Date();
      if(ms <= 0){
        ms = 0;
        const lbl = $('[data-count-label]', box); if(lbl) lbl.textContent = 'This drop is closed';
        $$('[data-product]', box).forEach(c => { if(c.dataset.closed !== '1'){ c.dataset.closed = '1'; c._sync && c._sync(); } });
      }
      const set = (s, v) => { const el = $(s, box); if(el) el.textContent = pad(v); };
      set('[data-d]', Math.floor(ms/864e5)); set('[data-h]', Math.floor(ms/36e5)%24);
      set('[data-m]', Math.floor(ms/6e4)%60); set('[data-s]', Math.floor(ms/1e3)%60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- film sound toggle ---------- */
  const film = $('[data-film]'), sound = $('[data-sound]');
  if(film && sound){
    sound.addEventListener('click', () => {
      film.muted = !film.muted;
      if(!film.muted){ film.currentTime = 0; film.play().catch(()=>{}); }
      sound.setAttribute('aria-pressed', !film.muted);
      sound.textContent = film.muted ? 'Sound on' : 'Sound off';
    });
  }

  /* ---------- wordmark color cycle (slow fades, no flashing) ---------- */
  const colors = (HS.wordmarkColors || []).map(c => c.trim()).filter(Boolean);
  const band = $('[data-band]');
  if(band && colors.length > 1 && !reduce){
    let i = 0; setInterval(() => { i = (i+1) % colors.length; band.style.color = colors[i]; }, 2600);
  }
})();
